import type { ReactNode } from "react";
import { create } from "zustand";

interface ModalState {
  component: ReactNode;
}

const useModalStore = create<ModalState>(() => ({
  component: null
}));

export function closeModal() {
  useModalStore.setState(() => ({ component: null }));
}

export function openModal(component: ReactNode) {
  useModalStore.setState(() => ({ component: component }));
}

export default useModalStore;
